import { ACTIVE_USERS_LIST_TAG } from '../constants';
import { api } from '../core';
import { UserRoleType } from './userAbout';

export type UserAddResponse = null;

type UserAddProps = {
  firstName: string;
  lastName: string;
  emailAddress: string;
  userRole: UserRoleType;
};

const userAddApi = api.injectEndpoints({
  endpoints: (builder) => ({
    postUserAdd: builder.query<UserAddResponse, UserAddProps>({
      query: ({ firstName, lastName, emailAddress, userRole }: UserAddProps) => ({
        url: 'users/add',
        method: 'POST',
        body: {
          firstName,
          lastName,
          emailAddress,
          userRole,
        },
      }),
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;

          dispatch(api.util.invalidateTags([ACTIVE_USERS_LIST_TAG]));
        } catch (error) {
          if (error instanceof Error && error.name === 'AbortError') {
            console.log('Request was aborted');
          } else {
            console.error('Error in postUserAdd in onQueryStarted:', error);
          }
        }
      },
      extraOptions: { maxRetries: 0 },
    }),
  }),
});

/**
 * Export hooks for usage in functional components, which are
 * auto-generated based on the defined endpoints
 */
export const { useLazyPostUserAddQuery } = userAddApi;
